






























































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { BrandConfigKeys } from "@/data/constants";
import { IBrand } from "@/models/brands";

interface AutomationIntervalsForm {
  suspend_interval: number;
  cancel_interval: number;
  close_interval: number;
}

@Component
export default class AutomationIntervalsControl extends Mixins(
  RequestPromises
) {
  // Props
  @Prop({ required: true })
  public value!: AutomationIntervalsForm;

  @Prop({ required: true })
  public brandId!: IBrand["id"];

  @Prop({ default: 0 })
  public minValue!: number;

  @Prop({ default: 90 })
  public maxValue!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isLoading = true;

  // Computed

  public get form(): AutomationIntervalsForm {
    return this.value;
  }

  public get i18n() {
    return {
      suspensionIntervalLabel: this.$tc(
        "_sentence.cprod.suspension_interval_label",
        this.form.suspend_interval,
        { days: this.form.suspend_interval }
      ),
      cancellationIntervalLabel: this.$tc(
        "_sentence.cprod.cancellation_interval_label",
        this.form.cancel_interval,
        { days: this.form.cancel_interval }
      ),
      terminationIntervalLabel: this.$tc(
        "_sentence.cprod.termination_interval_label",
        this.form.close_interval,
        { days: this.form.close_interval }
      )
    };
  }

  public get maxSuspendInterval() {
    return Math.max(
      this.maxValue,
      this.$store.getters["brand/config"][
        BrandConfigKeys.SUBSCRIPTIONS_SUSPEND_INTERVAL
      ] ?? this.maxValue
    );
  }

  public get maxCloseInterval() {
    return Math.max(
      this.maxValue,
      this.$store.getters["brand/config"][
        BrandConfigKeys.SUBSCRIPTIONS_CLOSE_INTERVAL
      ] ?? this.maxValue
    );
  }

  public get maxCancelInterval() {
    return Math.max(
      this.maxValue,
      this.$store.getters["brand/config"][
        BrandConfigKeys.SUBSCRIPTIONS_CANCEL_INTERVAL
      ] ?? this.maxValue
    );
  }

  // Life-cycle Methods

  public async created() {
    try {
      await this.getDefaultBrandIntervals();
    } finally {
      this.isLoading = false;
    }
  }

  // Methods

  public getDefaultBrandIntervals(ignoreStored = false) {
    return this.$store.dispatch("brand/getConfig", {
      brandId: this.brandId,
      keys: [
        BrandConfigKeys.SUBSCRIPTIONS_SUSPEND_INTERVAL,
        BrandConfigKeys.SUBSCRIPTIONS_CANCEL_INTERVAL,
        BrandConfigKeys.SUBSCRIPTIONS_CLOSE_INTERVAL
      ],
      ignoreStored
    });
  }
}
